import * as M from "../../data/model";

export class ModelState {
    ConsultationProcess: M.ConsultationProcess = undefined;
}
